import { getApiRoot, getWebClientId } from "../@api/config";
import { getJsonResponse } from "../@api/jsonResponse";
import type { TunnistusState } from "../store/auth";
import { initialTunnistusState } from "../store/auth";

interface CommonTunnistusResponse {
  receiver_ssn: string;
  receiver_given_name: string;
  receiver_last_name: string;
  receiver_email: string;
  receiver_info_source: string;
}
interface ExistingUserResponse extends CommonTunnistusResponse {
  new_user: false;
  access_token: string;
  expires_in: number;
  scope: string;
  token_type: string;
  resource_owner: string;
}

interface NewUserResponse extends CommonTunnistusResponse {
  new_user: true;
  signature: string;
}

type TunnistusResponse = NewUserResponse | ExistingUserResponse;

export const isNewUserResponse = (
  response: TunnistusResponse,
): response is NewUserResponse => response.new_user;

export const tunnistusPost = (
  code: string,
  currentUrl: string,
  acr_values: string,
): Promise<TunnistusResponse> =>
  fetch(`${getApiRoot()}/tunnistus`, {
    method: "POST",
    body: JSON.stringify({
      client_id: getWebClientId(),
      code,
      redirect_uri: currentUrl, // This is verified by Telia Tunnistus
    }),
    headers: {
      "Content-Type": "application/json",
      "ACR-Values": acr_values,
    },
  }).then(getJsonResponse);

export const mapTunnistusResponseToState = (
  response: TunnistusResponse,
): TunnistusState => {
  const commonValues = {
    isNewUser: response.new_user,
    ssn: response.receiver_ssn,
    emailAddress: response.receiver_email,
    givenName: response.receiver_given_name,
    lastName: response.receiver_last_name,
    infoSource: response.receiver_info_source,
  };
  if (isNewUserResponse(response)) {
    return {
      ...initialTunnistusState,
      ...commonValues,
      signature: response.signature,
    };
  }
  return {
    ...initialTunnistusState,
    ...commonValues,
    accessToken: response.access_token,
    resourceOwner: response.resource_owner,
    tokenType: response.token_type,
  };
};
